export var defaultProps = {
    className: '',
    style: undefined,
    format: 'HH:mm:ss',
    disabled: false,
    placeholder: '请选择时间',
    now: true,
    nowText: '此刻',
    showClear: true,
    confirmText: '确定',
    hourStep: 1,
    minuteStep: 1,
    secondStep: 1,
    bordered: true,
    showIcon: true,
    model: 'single',
    onChange: function (value, e) { },
    onBeforeChange: function (value, e) { return true; },
    onFocus: function (e) { },
    onBlur: function (e) { },
};
export var defaultTimeSelectProps = {
    type: 'h',
    options: [],
    defaultValue: '',
    open: false,
    panel: 'default',
};
export var defaultRangeProps = {
    className: '',
    style: undefined,
    format: 'HH:mm:ss',
    disabled: false,
    placeholder: ['开始时间', '结束时间'],
    onChange: function (value, e) { },
    onBeforeChange: function (value, e) { return true; },
};
export var defaultTimeComboBoxProps = {
    panel: 'default',
    open: false,
    format: 'HH:mm:ss',
    nowText: '此刻',
    confirmText: '确定',
    showNow: true,
    hourStep: 1,
    secondStep: 1,
    minuteStep: 1,
    onChange: function () { },
};
